import { isNull as isNullLodash } from 'lodash'

export const isNull = isNullLodash
